import { Paper, Stack, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'

interface ProjectLessonInfoBoxProps {
  projectName: string
  lessonTitle: string
}

export function ProjectLessonInfoBox({ projectName, lessonTitle }: ProjectLessonInfoBoxProps) {
  const { t } = useTranslation()
  if (!projectName && !lessonTitle) return null
  return (
    <Paper withBorder radius="md" p="md">
      <Stack spacing={2}>
        {projectName && (
          <Text size="sm">
            <Text span color="dimmed">
              {`${t('arc_teacher_assessment_drawer.project_label')}: `}
            </Text>
            <Text span>{projectName}</Text>
          </Text>
        )}
        {lessonTitle && (
          <Text size="sm">
            <Text span color="dimmed">
              {`${t('arc_teacher_assessment_drawer.lesson_label')}: `}
            </Text>
            <Text span>{lessonTitle}</Text>
          </Text>
        )}
      </Stack>
    </Paper>
  )
}
